import styled from 'styled-components';
import { TabPanelMixin } from '../../mixins/components/TabPanelMixin';
export var StyledTabPanel = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTabPanel",
  componentId: "c11n-8-107-0__sc-1d0sn23-0"
})(["", ""], TabPanelMixin);